import { optionsToStrategy } from "@/common/utils/optionsToStrategy";

export const fiscalDocumentKind = {
  'none': 'Nenhum',
  'nfs': 'Nota fiscal por serviço (NFs)',
  'nfe': 'Nota fiscal eletrônica (NF-e)',
};

export const fiscalDocumentKindOptions = Object.entries(fiscalDocumentKind).map(([value, label]) => ({ value, label }));

export const fiscalDocumentKindStrategy = optionsToStrategy(fiscalDocumentKindOptions);